/** InsCoder WANG.J 2026-08-04 B + Responsive pagination mode (separate desktop/mobile modes) **/
(function() {
  if (typeof theme === 'undefined' || !theme.Collection) return;

  var BREAKPOINT = (theme.breakpoints && theme.breakpoints.medium) ? theme.breakpoints.medium : 750;

  function resolvePagination(container) {
    var desktopMode = container.getAttribute('data-pagination_mode') || 'standart';
    var mobileMode = container.getAttribute('data-pagination_mode_mobile') || desktopMode;
    var isMobile = window.innerWidth < BREAKPOINT;
    return {
      isMobile: isMobile,
      mode: isMobile ? mobileMode : desktopMode,
      paginationSelector: isMobile ? '#AjaxinatePaginationMobile' : '#AjaxinatePaginationDesktop'
    };
  }

  theme.Collection.prototype._initAjaxinate = function() {
    if (typeof Ajaxinate === 'undefined') return;

    // Destroy any previous instance first to avoid duplicated listeners
    if (this.ajaxinateInstance) {
      try {
        this.ajaxinateInstance.destroy();
      } catch (e) {}
      this.ajaxinateInstance = null;
    }

    var current = resolvePagination(this.container);

    if (current.mode === 'standart') return;

    // Bind once: re-init when crossing the mobile/desktop breakpoint
    var containerEl = this.container;
    if (!containerEl.__paginationModeBound) {
      containerEl.__paginationModeBound = true;
      var self = this;
      var mql = window.matchMedia('(max-width: ' + (BREAKPOINT - 1) + 'px)');
      var refresh = function() {
        self._initAjaxinate();
      };
      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', refresh);
      } else if (typeof mql.addListener === 'function') {
        mql.addListener(refresh);
      }
    }

    this.ajaxinateInstance = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: current.paginationSelector,
      method: current.mode,
      offset: 500
    });
  };
})();
/** InsCoder WANG.J 2026-08-04 E + Responsive pagination mode (separate desktop/mobile modes) **/
